import { appLocalStorage } from '../utils/storage';
export const draftIdentityKey = (userId, storyId) => `opinion-draft:${userId}:${storyId}`;
export const newMediaId = () => window.crypto?.randomUUID?.()
  || `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;

const sessionIds = new Map();
const retiredIds = new Map();
export function opinionDraftId(userId, storyId) {
  const key = draftIdentityKey(userId, storyId);
  try {
    const saved = appLocalStorage.getItem(key);
    if (saved && saved !== retiredIds.get(key)) return saved;
    const id = sessionIds.get(key) || newMediaId();
    appLocalStorage.setItem(key, id);
    sessionIds.set(key, id);
    return id;
  } catch {
    if (!sessionIds.has(key)) sessionIds.set(key, newMediaId());
    return sessionIds.get(key);
  }
}

export function clearDraftIdentity(userId, storyId) {
  const key = draftIdentityKey(userId, storyId);
  sessionIds.delete(key);
  try { appLocalStorage.removeItem(key); } catch { /* Saving has already succeeded. */ }
}

// Once publication succeeds, disk cleanup is housekeeping. Retire its local
// generation first so a slow/failed IndexedDB delete cannot restore an already
// published recording when this opinion is opened again. A late completion
// belonging to an older editor must not replace a newer editor's identity.
export function retireDraftIdentity(userId, storyId, expectedId) {
  const key = draftIdentityKey(userId, storyId);
  let stored;
  try { stored = appLocalStorage.getItem(key); } catch { /* Use the in-memory owner. */ }
  const current = stored && stored !== retiredIds.get(key) ? stored : sessionIds.get(key);
  if (current && current !== expectedId) return;
  // Preserve the obsolete disk value through repeated publications while
  // writes are unavailable. The in-memory generation may have advanced twice
  // even though getItem still returns the same old value.
  if (stored || !retiredIds.has(key)) retiredIds.set(key, stored || expectedId);
  const next = newMediaId();
  sessionIds.set(key, next);
  try { appLocalStorage.setItem(key, next); }
  catch {
    // Removing a key can still work when storage is at quota. Do not retain
    // the completed identity merely because the replacement could not fit.
    try { appLocalStorage.removeItem(key); } catch { /* Keep the in-memory replacement. */ }
  }
}
